module.exports = __webpack_public_path__ + "img/create-wallet-m-3.14be3529.png";